import "./styles.scss";
import { SideMenu } from "../../../components/SideMenu";
import { Filter } from "../../../components/Filter";
import Pagination from "react-js-pagination";
import { NavLink, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import {
  APPS_GET,
  APP_DELETE,
  APPS_GET_PAGE,
  APPS_GET_FILTER,
} from "../../../API/appApi.js";
import { Search } from "../../../components/Search";

export function Applications() {
  const [data, setData] = useState([
    {
      id: Number,
      name: "",
      active: Number,
      fk_id_campain: Number,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState([]);
  const [error, setError] = useState(false);

  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");

  const [text, setText] = useState("");
  const [search, setSearch] = useState([]);

  useEffect(() => {
    async function getAppFilter() {
      if (text.length >= 3) {
        const { url, options } = APPS_GET_FILTER(token, text);

        setLoading(true);

        const searchResponse = await fetch(url, options);
        const searchJson = await searchResponse.json();

        setSearch(searchJson.data);

        setLoading(false);
      }
    }

    getAppFilter();
  }, [text, token]);

  async function getApps() {
    setLoading(true);

    const { url, options } = APPS_GET(token);

    const appResponse = await fetch(url, options);
    if (!appResponse.ok) {
      setError(
        "Houve um erro ao carregar os dados, contate o suporte ou tente novamente mais tarde."
      );
    }
    const appJson = await appResponse.json();

    setPagination(appJson.data);
    setData(appJson.data.data);

    setLoading(false);
  }

  useEffect(() => {
    getApps();
  }, []);

  async function getAppPage(pageNumber) {
    let page = pageNumber + 1;
    const { url, options } = APPS_GET_PAGE(token, page);
    setLoading(true);

    const clientsPageResponse = await fetch(url, options);
    if (!clientsPageResponse.ok) {
      setError(
        "Houve um erro ao carregar os dados, contate o suporte ou tente novamente mais tarde."
      );
      setLoading(false);
    }
    const clientsPageJson = await clientsPageResponse.json();

    setPagination(clientsPageJson.data);
    setData(clientsPageJson.data.data);

    setLoading(false);
  }

  async function handleDelete(id) {
    const { url, options } = APP_DELETE(id, token);
    await fetch(url, options);
    await getApps();
  }

  function handleEdit(id) {
    navigate(`/app/edit-app/${id}`);
  }

  return (
    <>
      <div>
        <SideMenu />
      </div>

      <div className="container fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <div>
                <i className="fas fa-ghost"></i>
                <h2>Aplicações</h2>
              </div>

              <div>
                <NavLink to="/app/new-app">
                  <button>Nova Aplicação</button>
                </NavLink>
              </div>
            </div>
            <Filter value={text} onChange={(search) => setText(search)} />
          </div>
        </div>

        <div className="userListContainer">
          <div className="menuList">
            <div className="row">
              <div className="col-md-1">
                <span>#</span>
              </div>
              <div className="col-md-3">
                <span>App</span>
              </div>
              <div className="col-md-4">
                <span>Token</span>
              </div>
              <div className="col-md-3">
                <span>Status</span>
              </div>

              <div className="col-md-1">
                <span>Ações</span>
              </div>
            </div>
          </div>

          {error ? <p>{error}</p> : ""}

          {text == false ? (
            <div className="userList">
              {loading
                ? "Carregando..."
                : data.map((item) => {
                    return (
                      <div className="row list" key={item.id}>
                        <div className="col-md-1 items">{item.id}</div>
                        <div className="col-md-3 items">
                          <span>{item.name}</span>
                        </div>

                        <div className="col-md-4">
                          <span className="token">{item.current_token}</span>
                        </div>

                        <div className="col-md-3 items">
                          <span
                            className={
                              item.active === 1 ? `active` : `inactive`
                            }
                          >
                            {item.active === 1 ? "Ativo" : "Inativo"}
                          </span>
                        </div>

                        <div className="col-md-1 actions">
                          <button onClick={() => handleEdit(item.id)}>
                            <i className="fas fa-ellipsis-v"></i>
                          </button>
                          {item.active === 1 ? (
                            <button onClick={() => handleDelete(item.id)}>
                              <i className="fas fa-ban"></i>
                            </button>
                          ) : (
                            <button
                              disabled
                              onClick={() => handleDelete(item.id)}
                            >
                              <i className="fas fa-ban"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}

              <div>
                {loading === true ? (
                  ""
                ) : (
                  <Pagination
                    totalItemsCount={pagination.total}
                    activePage={pagination.current_page}
                    onChange={(pageNumber) => getAppPage(pageNumber)}
                    itemsCountPerPage={pagination.per_page}
                    itemClass="page-item"
                    firstPageText="Primeira"
                    lastPageText="Ultima"
                  />
                )}
              </div>
            </div>
          ) : (
            <>
              {loading ? (
                "Carregando.."
              ) : (
                <Search
                  loading={loading}
                  search={search}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
